"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTokenAdminProxyFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_logic",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementationAddress",
                type: "address",
            },
        ],
        name: "ImplementationChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newAdmin",
                type: "address",
            },
        ],
        name: "changeProxyAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tEther",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class TTokenAdminProxyFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_logic, _data, overrides) {
        return super.deploy(_logic, _data, overrides || {});
    }
    getDeployTransaction(_logic, _data, overrides) {
        return super.getDeployTransaction(_logic, _data, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TTokenAdminProxyFactory = TTokenAdminProxyFactory;
TTokenAdminProxyFactory.bytecode = _bytecode;
TTokenAdminProxyFactory.abi = _abi;
//# sourceMappingURL=TTokenAdminProxyFactory.js.map